// Phase 1A Step 34 — Section 08 Legal Clarity Strip.
// Verbatim port from handoff/landing-reference/sections.jsx LegalStrip.
// Three columns: Tool not bookmaker / Responsible Play / Compliant by default.
// Per handoff README: "every line is load-bearing — do not paraphrase".

export function LegalStrip(): JSX.Element {
  return (
    <section
      style={{
        padding: "48px 0",
        background: "var(--surface)",
        borderTop: "1px solid var(--border)",
        borderBottom: "1px solid var(--border)",
      }}
    >
      <div className="container">
        <div
          className="sz-l-legal-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1px 1fr 1px 1fr",
            gap: 40,
            alignItems: "center",
          }}
        >
          <div>
            <div
              className="mono"
              style={{
                fontSize: 10,
                color: "var(--accent)",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              Tool, not bookmaker
            </div>
            <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>
              STRIKZA is a betting intelligence tool.{" "}
              <span style={{ color: "var(--text)" }}>
                You place every bet. We build every insight.
              </span>
            </div>
          </div>
          <div
            className="sz-l-legal-divider"
            style={{
              width: 1,
              height: 56,
              background: "var(--border-bright)",
              margin: "0 auto",
            }}
          />
          <div>
            <div
              className="mono"
              style={{
                fontSize: 10,
                color: "var(--accent)",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              Responsible Play
            </div>
            <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>
              Stake only what you can afford to lose.{" "}
              <span style={{ color: "var(--text)" }}>18+.</span> Self-exclusion tools available in
              app.
            </div>
          </div>
          <div
            className="sz-l-legal-divider"
            style={{
              width: 1,
              height: 56,
              background: "var(--border-bright)",
              margin: "0 auto",
            }}
          />
          <div>
            <div
              className="mono"
              style={{
                fontSize: 10,
                color: "var(--accent)",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              Compliant by default
            </div>
            <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>
              Data Protection Act <span style={{ color: "var(--text)" }}>843</span> compliant. Your
              data stays in West Africa.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
